module.exports = __webpack_public_path__ + "static/media/chm-bau3.a3d7b504.gif";